import { I_TRADE_ACTION as types } from "../../constants/i-trade";
import { Converter, Filter } from "../../helpers/functions";

const initialState = {
  tradingAccounts: [],
  currentTradingAccount: {},
  markets: [],
  clientID: "",
  tradeConfigSettings: {},
  currentMarket: "",
  tradeDateInfoList: [],
  goodTillDates: [],
  orderTypes: [],
  clientCCYList: [
    {
      id: "hkd",
      label: "HKD",
    },
  ],
  instrumentInfo: {},
  portfolios: null,
  marketParams: {},
  NCmarketParams: {},
  priceParams: {},
  mdsToken: "",
  stopQutoRefresh: "false",
  mdsAccountType: {},
  instrumentHistoricalData: [],
  cashAccountData: {},
  passwordRule: {},
  assetloading: "",
  depositBankAccount: "",
  OtherWithdrawalBankAccount: "",
  WithdrawalBankAccount: "",
  quoteDeatil: { bidData: Array(5).fill({ price: "-", qty: "-" }), askData: Array(5).fill({ price: "-", qty: "-" }) },
};

export const tradeAccountReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_TRADING_ACCOUNT:
      return Object.assign({}, state, {
        tradingAccounts:
          Converter.mapTradeAccountToOption(action.tradingAccounts) ||
          Converter.mapTradeAccountToOption(state.tradingAccounts),
        currentTradingAccount:
          Filter.filterDefaultTradingAccount(
            Converter.mapTradeAccountToOption(action.tradingAccounts)
          ) ||
          Filter.filterDefaultTradingAccount(
            Converter.mapTradeAccountToOption(state.tradingAccounts)
          ),
        clientID: action.clientID || state.clientID,
      });
    case types.GET_MARKET:
      return Object.assign({}, state, {
        markets: action.markets || state.markets,
      });
    case types.SET_PLACE_ORDER_PARAMS:
      return Object.assign({}, state, {
        priceParams: {
          marketID: action.marketID || state.marketID,
          instrumentID: action.instrumentID || state.instrumentID,
          price: action.price || state.price,
          quantity: action.quantity || state.quantity,
          tradableQty: action.tradableQty || state.tradableQty,
        },
      });
    case types.SET_CURRENT_TRADING_ACCOUNT:
      return Object.assign({}, state, {
        currentTradingAccount: action.currentTradingAccount,
        clientID: action.clientID || action.clientID,
      });
    case types.SWITCH_TRADING_ACCOUNT:
      return Object.assign({}, state, {
        currentTradingAccount: action.currentTradingAccount,
        clientID: action.clientID || action.clientID,
      });
    case types.GET_TRADING_CONFIG_SETTING:
      return Object.assign({}, state, {
        tradeConfigSettings: action.tradeConfigSettings,
      });
    case types.SET_CURRENT_MARKET:
      return Object.assign({}, state, {
        currentMarket: action.currentMarket || state.currentMarket,
      });
    case types.SET_TRADE_DATE_INFO:
      return Object.assign({}, state, {
        tradeDateInfoList: action.tradeDateInfoList || state.tradeDateInfoList,
      });
    case types.SET_GOOD_TILL_DATE:
      return Object.assign({}, state, {
        goodTillDates: action.goodTillDates || state.goodTillDates,
      });
    case types.SET_ORDER_TYPE:
      return Object.assign({}, state, {
        orderTypes: action.orderTypes || state.orderTypes,
      });
    case types.GET_CLIENT_CCY_LIST:
      return Object.assign({}, state, {
        clientCCYList: action.clientCCYList || state.clientCCYList,
      });
    case types.GET_INSTRUMENT_INFO:
      return Object.assign({}, state, {
        instrumentInfo: action.instrumentInfo || state.instrumentInfo,
      });
    case types.GET_POSITION_DATA:
      return Object.assign({}, state, {
        portfolios: action.portfolios || state.portfolios,
      });
    case types.SET_MARKET_STOCK:
      return Object.assign({}, state, {
        marketParams: {
          stockCode: action.stockCode || state.stockCode,
          marketID: action.marketID || state.marketID,
          stockName: action.stockName || state.stockName,
        },
      });
    case types.SET_NO_CHANGE_MARKET_STOCK:
      return Object.assign({}, state, {
        NCmarketParams: {
          NCstockCode: action.NCstockCode || state.NCstockCode,
          NCmarketID: action.NCmarketID || state.NCmarketID,
          NCstockName: action.NCstockName || state.NCstockName,
        },
      });
    case types.SET_MDS_TOKEN:
      return Object.assign({}, state, {
        mdsToken: action.mdsToken || state.mdsToken,
      });
    case types.SET_QUOTE_ACCOUNT:
      return Object.assign({}, state, {
        mdsAccountType: action.mdsAccountType || state.mdsAccountType,
      });
    case types.STOP_QUTO_REFRESH:
      return Object.assign({}, state, {
        stopQutoRefresh: action.stopQutoRefresh || state.stopQutoRefresh,
      });
    case types.GET_INSTRUMENT_HISTORICAL_DATA:
      return Object.assign({}, state, {
        mdsToken:
          action.instrumentHistoricalData || state.instrumentHistoricalData,
      });
    case types.GET_ACCOUNT_BANLANCE:
      return Object.assign({}, state, {
        cashAccountData: action.cashAccountData || state.cashAccountData,
        assetloading: action.assetloading || action.assetloading,
      });
    case types.GET_AVAIABLE_QUANTITY:
      return Object.assign({}, state, {
        avaiableQuantity: action.avaiableQuantity || state.avaiableQuantity,
      });
    case types.CLEAR_TRADING_ACCOUNT:
      return Object.assign({}, state, {
        tradingAccounts: [],
        currentTradingAccount: {},
        clientID: "",
      });
    case types.GET_PASSWORD_RULE:
      return Object.assign({}, state, {
        passwordRule: action.passwordRule,
      });
    case types.SET_DEPOSIT_BANK_ACCOUNT:
      return Object.assign({}, state, {
        depositBankAccount: action.depositBankAccount,
      });
    case types.SET_WITHDRAWAL_BANK_ACCOUNT:
      return Object.assign({}, state, {
        OtherWithdrawalBankAccount: action.OtherWithdrawalBankAccount,
      });
    case types.SET_WITHDRAWAL_BANK_ACCOUNT2:
      return Object.assign({}, state, {
        WithdrawalBankAccount: action.WithdrawalBankAccount,
      });
    case types.GET_QUOTE_DETAIL:
      return { ...state, quoteDeatil: action.quoteDeatil };
    default:
      return state;
  }
};
